<button 
    pButton 
    pRipple 
    type="button" 
    (click)="onClick.emit($event)" 
    [icon]="bindingIcon" 
    iconPos="right" 
    [label]="bindingLabel|translate" 
    class="p-button-sm custom-button"
    [class] = bindingClassName
></button>
